import { createSlice } from "@reduxjs/toolkit";
import User from "src/models/Base/Auth/User";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { authApi } from "src/services/Auth/AuthApi";
import { kimlikApi } from "src/services/Genel/KimlikApi";

type UserPayload = User & { Culture?: string; CultureLang?: string };
type MaybeWrappedUser = UserPayload | { data: UserPayload } | { Data: UserPayload } | unknown;

function unwrapUserPayload(payload: MaybeWrappedUser): UserPayload {
  const p = payload as Record<string, unknown>;
  if (p && typeof p === 'object') {
    if ('data' in p && p.data) return p.data as UserPayload;
    if ('Data' in p && p.Data) return p.Data as UserPayload;
  }
  return payload as UserPayload;
}

function normalizeCulture(u: UserPayload): { culture: string | null; cultureLang: string | null } {
  const culture = u.culture ?? u.Culture ?? null;
  const cultureLang = u.cultureLang ?? u.CultureLang ?? null;
  return { culture, cultureLang };
}

export interface IUserState {
  userInfo: User;
  newPassword: boolean;
  passwordChanged: boolean;
  isButtonDisabled: boolean,
  Loginkod: string,
  Password: string,
  isLoggedIn: boolean,
  skip: boolean,
  eImzaPin: string,
  eImza: boolean,
  eImzaId: string,
  formSize: number,
  culture?: string,
  cultureLang?: string
}
const user: User = sessionStorage.getItem('userLogin')
  ? JSON.parse(sessionStorage.getItem('userLogin'))
  : {};
const userCulture = sessionStorage.getItem('userCulture')
  ? JSON.parse(sessionStorage.getItem('userCulture'))
  : {};
const AuthSlice = createSlice<IUserState, MapReducerPayloads<IUserState, {
  setState: IUserState,
  setNewPassword: boolean,
  logOut: void,
  setFormSize: number
}>>({
  name: 'user',
  initialState: {
    newPassword: false,
    userInfo: user,
    passwordChanged: false,
    isButtonDisabled: false,
    Loginkod: "",
    Password: "",
    isLoggedIn: user.id > 0,
    skip: true,
    eImzaPin: "",
    eImza: false,
    eImzaId: "",
    formSize: 12,
    culture: userCulture.culture,
    cultureLang: userCulture.cultureLang
  },
  reducers: {
    setState: (state, action) => action.payload,
    setNewPassword: (state, action) => {
      state.newPassword = action.payload
    },
    logOut: (state, action) => {
      sessionStorage.clear();
      state.userInfo = {}
      window.location.href = window.location.origin;
    },
    setFormSize: (state, action) => {
      state.formSize = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(authApi.endpoints.login.matchFulfilled, (state, action) => {
      const data = unwrapUserPayload(action.payload);
      const { culture, cultureLang } = normalizeCulture(data);

      sessionStorage.setItem("userLogin", JSON.stringify({ ...data, culture, cultureLang }));
      if (culture || cultureLang) {
        sessionStorage.setItem('userCulture', JSON.stringify({ culture, cultureLang }));
      }

      state.userInfo = { ...data, culture, cultureLang };
      state.isLoggedIn = Boolean(data?.id > 0);
      state.newPassword = data?.yenisifreverildi === "E";
      state.culture = culture ?? state.culture;
      state.cultureLang = cultureLang ?? state.cultureLang;
    });
    
    builder.addMatcher(authApi.endpoints.OrganizasyonSecim.matchFulfilled, (state, action) => {
      const data = unwrapUserPayload(action.payload);
      const { culture, cultureLang } = normalizeCulture(data);

      sessionStorage.setItem("userLogin", JSON.stringify({ ...data, culture, cultureLang }));
      if (culture || cultureLang) {
        sessionStorage.setItem('userCulture', JSON.stringify({ culture, cultureLang }));
      }

      state.userInfo = { ...data, lisansGun: state.userInfo.lisansGun, culture, cultureLang };
      state.isLoggedIn = Boolean(data?.id > 0);
      state.newPassword = data?.yenisifreverildi === "E";
      state.culture = culture ?? state.culture;
      state.cultureLang = cultureLang ?? state.cultureLang;
    });
    builder.addMatcher(kimlikApi.endpoints.getByLoginKimlikId.matchFulfilled, (state, action) => {
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          foto: action.payload.fotograf
        }
      }
    })
  }
})
export default AuthSlice;